import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import ModelService from "../API/ModelService"
import MyLoader from "../components/UI/Loader/MyLoader"
import { useFetching } from "../hooks/useFetching"

const ModelIdPage = () => {
    const params = useParams()
    // console.log(params)
    const [model, setModel] = useState({})
    const [comments, setComments] = useState([])

    // downloads modal by Id
    const [fetchModelById, isLoading, error] = useFetching(async (id) => {
        const response = await ModelService.getById(id)
        setModel(response.data)
    })

    // downloads Comments for modal by Id
    const [fetchComments, isComLoading, comError] = useFetching(async (id) => {
        const response = await ModelService.getCommentByModelId(id)
        setComments(response.data)
    })

    useEffect( () => {
        fetchModelById(params.id)
        fetchComments(params.id)
    }, [])

    return (
        <div>
            <h1>This is a page of Model No. {params.id}</h1>
            {isLoading
            ? <MyLoader />
            : <div>
                <h3>{model.id}. {model.title}</h3>
                <div>{model.body}</div>
            </div>
            }
            <h1>Comments:</h1>
            {isComLoading
                ? <MyLoader />
                : <div>
                    {comments.map(comm => 
                        <div key={comm.id} style={{marginTop: '15px'}}>
                            <h5>{comm.email}</h5>
                            <div>{comm.name}</div>
                            <div>{comm.body}</div>
                        </div>
                    )}
                </div>
            }
        </div>
    )
}

export default ModelIdPage